<template>
  <div>
    <VideoChallenge/>
    <charts></charts>
    <category></category>
    <!-- <section>
      <div class="appstore_sec col-xs-12">
                <div class="container">
                    <div class="row">
                        <div class="mobile col-sm-5 col-xs-10">
                            <img title="Mobile image" src="../assets/images/mobile.png" alt="mobile " width="330" height="273">
                        </div>
                        <div class="app_data col-sm-7 col-xs-12">
                            <h4>Download the app</h4>
                            <p></p>
                            <p></p>

                            <a target="_blank"  href="#"><img src="../assets/images/appstore_icon.png" title="Appstore Airvisual app" alt="App Store f" width="120" height="41"></a>


                            <a target="_blank"  href="#"><img src="../assets/images/android_dl.png" title="Google market Airvisual app" alt="Google Market" width="120" height="41"></a>

                        </div>
                        <div class="clear"></div>
                    </div>
                </div>
        </div>
        <div class="clear"></div>
    </section> -->
   <!-- <air-visual></air-visual> -->
  </div>
</template>
<script>
import Charts from './Charts.vue'
import Category from './Category.vue'
import VideoChallenge from './VideoChallenge.vue'

import AirVisual from './AirVisual.vue'
export default {
  name: 'home',
  data () {
    return {
    }
  },
  components: {
      Charts,
      Category,
      AirVisual,
      VideoChallenge
  }
}
</script>



// WEBPACK FOOTER //
// Home.vue?48b26686